import roboticImage from "../../assets/images/login_page_roboticImg.png";
import useTheme from "../../pages/hooks/useTheme.ts";
import BrandLogo from "../../assets/components/BrandLogo.tsx";

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isDark } = useTheme();

  return (
    <div
      className="
        h-screen
        overflow-hidden
        bg-[rgb(var(--background))]
      "
    >
      <div className="flex h-full flex-col xl:flex-row">
        {/* =========================================
            LEFT SECTION
        ========================================== */}

        <div
          className="
            relative
            flex
            flex-col
            w-full
            items-center
            overflow-y-auto
            px-5
            py-8
            sm:px-8
            lg:px-12
            xl:w-[44%]
            xl:py-0
            xl:pb-6
          "
        >
          {/* Glow */}
          <div className="absolute top-[-120px] left-[-120px] h-[280px] w-[280px] rounded-full bg-[rgba(184,137,58,0.08)] blur-3xl" />

          {/* LOGO */}
          <div className="w-full flex items-center gap-3 mb-6 xl:mt-8">
            <BrandLogo isDark={isDark} />
          </div>

          <div className="relative z-10 w-full h-full max-w-[430px] flex flex-col 2xl:justify-center">
            {/* AUTH CARD */}
            <div
              className="
                rounded-md
                border border-[rgb(var(--border-primary))]
                bg-[rgba(255,255,255,0.74)]
                dark:bg-[rgba(14,14,18,0.82)]
                backdrop-blur-2xl
                p-6
                sm:p-8
                shadow-[var(--shadow-card-hover)]
              "
            >
              {children}
            </div>
          </div>
        </div>

        {/* =========================================
            RIGHT SECTION
        ========================================== */}

        <div
          className="
            relative
            outer-container
            hidden
            xl:flex
            xl:w-[56%]
            overflow-hidden
            bg-[rgb(var(--surface-1))]
          "
        >
          {/* Background Gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-[rgba(184,137,58,0.10)] via-transparent to-transparent" />

          {/* Ambient Glow */}
          <div className="absolute right-[-100px] top-[-100px] h-[320px] w-[320px] rounded-full bg-[rgba(184,137,58,0.12)] blur-3xl" />

          <div className="absolute bottom-[-120px] left-[-120px] h-[280px] w-[280px] rounded-full bg-[rgba(184,137,58,0.08)] blur-3xl" />

          {/* Content */}
          <div
            className="
              relative
              z-10
              flex
              h-full
              w-full
              flex-col
              px-10
              2xl:px-16
            "
          >
            {/* Top Label */}
            <div className="my-5 flex items-center gap-3">
              <div className="h-px w-12 bg-[rgb(var(--color-gold-2))]" />

              <span className="page-breadcrumb">LIVE EYE SURVEILLANCE</span>

              <div className="h-px w-12 bg-[rgb(var(--color-gold-2))]" />
            </div>

            {/* Heading */}
            <h1
              className="
                max-w-[680px]
                text-[42px]
                2xl:text-[46px]
                font-extralight
                leading-[1.2]
                tracking-[-0.04em]
                text-[rgb(var(--text-secondary))]
              "
            >
              Unveil the Future of Protection with our cutting-edge AI solutions
            </h1>

            {/* Image */}
            <div
              className="
                absolute
                bottom-0
                right-0
                flex
                w-full
                justify-end
                pointer-events-none
              "
            >
              <img
                src={roboticImage}
                alt="robotic-ai"
                className="
                  max-h-[78vh]
                  w-auto
                  object-contain
                  opacity-95
                  select-none
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
